import React, { Component } from 'react';
import { dateToTime } from '../../helpers';
import {toUpper} from 'lodash';
import { appBasePath } from '../../constants/staticData';

export default class ResultCard extends Component {
  render() {
    const { resultData, router } = this.props;
    let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    let requestStatusID = resultData.requeststatus && resultData.requeststatus.id && resultData.requeststatus.id
    let jobStartDate = new Date(requestStatusID == 2 ? resultData.createdAt : resultData.userPrefferedDatetime);
    let dateText = requestStatusID == 2 ? 'RECEIVED ON: ' :(requestStatusID == 1 || requestStatusID == 4) ? 'SCHEDULED ON: ' : 'STARTED ON: ';
    return (
      <div onClick={(e) => { e.preventDefault(); resultData.userbookingrequest_services && resultData.userbookingrequest_services.length && router.push(`${appBasePath}/job/${resultData.userbookingrequest_services[0].userbookingrequestId}`); }}>
        <div className={"result-search result-card " + (resultData.services && resultData.services.name && resultData.services.name == 'Servicing' ? 'service' : resultData.services.name.toLowerCase())}>
          <div className="result-card-title">
            <label>{resultData.requestid + ' - ' + (resultData.vehicles && resultData.vehicles.make + ' ' + resultData.vehicles.model)}</label>
            <span>{resultData.userbookingrequest_services && resultData.userbookingrequest_services.length ? resultData.userbookingrequest_services[0].name : ''}
              {resultData.userbookingrequest_services && resultData.userbookingrequest_services.length > 1 && ' + ' + (resultData.userbookingrequest_services.length-1) + ' More'}</span>
          </div>
          <div className="result-card-status-icon">
            {resultData.isurgentrequest && <i className="mdi mdi-timer-sand" />}
          </div>
          <div className="result-card-time">
            <label>{dateText + toUpper(months[jobStartDate.getMonth()]) + ' ' + jobStartDate.getDate() + ', ' + jobStartDate.getFullYear()}</label>
            <span>{toUpper(dateToTime(jobStartDate))}</span>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Results/ResultCard.jsx